export default function TypingIndicator() {
  return (
    <div className="flex items-center gap-1 px-4 py-3 bg-gray-100 rounded-2xl rounded-tl-sm w-fit">
      <div className="typing-dot w-2 h-2 bg-gray-400 rounded-full"></div>
      <div className="typing-dot w-2 h-2 bg-gray-400 rounded-full"></div>
      <div className="typing-dot w-2 h-2 bg-gray-400 rounded-full"></div>
      <span className="sr-only">Assistant is typing...</span>
    </div>
  );
}
